module.exports = __webpack_public_path__ + "static/kid_with_yellow_cape_pretending_to_fly_in_front_of_pool-b7f370bfa734171ecce713b204866d02.jpeg";